// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DesktopFileView_loadProgress{
    padding: 10px;
    background-color: #fff;
    border-radius: 5px;
    position: absolute;
    right: 0;
    bottom: 0;
    width: 200px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    box-shadow: 0px 3px 8px rgba(209, 215, 234, 1), 0px 3px 1px rgba(209, 215, 234, 1);
}

.DesktopFileView_loadProgress_title{
    font-size: 10px;
    font-weight: 700;
}

.DesktopFileView_loadProgress_item{
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.DesktopFileView_loadProgress_item_top{
    display: flex;
    justify-content: space-between;
}

.DesktopFileView_loadProgress_item_name{
    font-size: 10px;
}

.DesktopFileView_loadProgress_item_percent{
    font-size: 10px;
}

.DesktopFileView_loadProgress_indicator{
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 6px;
    overflow: hidden;
}

.DesktopFileView_loadProgress_bar{
    border-radius: 6px;
    height: 4px;
    background-color: #090;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/desktop/DesktopFileViewLoadProgress.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kFAAkF;AACtF;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B","sourcesContent":[".DesktopFileView_loadProgress{\n    padding: 10px;\n    background-color: #fff;\n    border-radius: 5px;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 200px;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    box-shadow: 0px 3px 8px rgba(209, 215, 234, 1), 0px 3px 1px rgba(209, 215, 234, 1);\n}\n\n.DesktopFileView_loadProgress_title{\n    font-size: 10px;\n    font-weight: 700;\n}\n\n.DesktopFileView_loadProgress_item{\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.DesktopFileView_loadProgress_item_top{\n    display: flex;\n    justify-content: space-between;\n}\n\n.DesktopFileView_loadProgress_item_name{\n    font-size: 10px;\n}\n\n.DesktopFileView_loadProgress_item_percent{\n    font-size: 10px;\n}\n\n.DesktopFileView_loadProgress_indicator{\n    width: 100%;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    overflow: hidden;\n}\n\n.DesktopFileView_loadProgress_bar{\n    border-radius: 6px;\n    height: 4px;\n    background-color: #090;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
